var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pa-4",class:{
    'ws-dashboard': !_vm.isAppDashboard,
    'app-dashboard':_vm.isAppDashboard
  }},[_c('Dashboard',{attrs:{"results-set":_vm.resultsSet,"context":_vm.context,"query-id":_vm.queryId,"query-configuration":_vm.queryConfiguration,"on-fire-query":_vm.onFireQuery}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }